import useAuth from "@/components/Authentication/hooks/useAuth";
import { RootState } from "@/store";
import { Button } from "@gisce/oficina-virtual-components";
import { ArrowOutward } from "@mui/icons-material";
import { 
  Box,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle 
} from "@mui/material"
import { t } from "i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { undefineToken } from "./utils/token";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

export const AuthTimeout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
	const { isAuthenticated } = useSelector((store: RootState) => store.auth);
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  axios.interceptors.response.use(function (response) {
    return response
  }, function (err) {
    if (axios.isAxiosError(err)) {
      if (err.response?.status === 401) {

        if (err.response && err.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = function() {
            if (typeof reader.result === "string") {
              const data = JSON.parse(reader.result);
              if (data.message == "token_expired"){
                undefineToken();
                setIsTokenExpired(true);
              }
            }
          };
          reader.readAsText(err.response.data);
        }

        if (err.response?.data?.message == "token_expired") {
          if (isAuthenticated) {
            undefineToken();
            setIsTokenExpired(true);
          }
        } 
      } 
      return Promise.reject(err);
    }
  })

  useEffect(() => {
    if (isAuthenticated && Cookies.get("token")) {
      setIsTokenExpired(false);
    }
  }, [isAuthenticated, Cookies.get("token")]);

  const handleTimeoutLogout = () => {
    setIsTokenExpired(false);
    logout();
  }

	return <Dialog
    open={isTokenExpired}
  >
    <Box sx={{padding: 2}}>

      <DialogTitle>{t("common:text.login_view_session_expired")}</DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          {t("common:text.login_view_session_expired_detail")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button 
          color="primary" 
          variant="contained" 
          onClick={() => handleTimeoutLogout()}
          startIcon={<ArrowOutward />}
        >
          {t("common:text.login_view_button_exit")}
        </Button>
      </DialogActions>

    </Box>

  </Dialog>
}